import styled from "styled-components";
import Colors from "../../themes/Colors";

const CardCampaignStatusHolder = styled.div`
  .cardGeneral {
    padding-left: 10px;
    padding-bottom: 10px;
    position: static;
    z-index: 996;
    height: auto;
    line-height: 25px;
    background-color: ${Colors.primary};
    font-size: 16px;
    text-align: center;
    color: ${Colors.onPrimary};
    border-radius: 8px;
    width: 100%;
    margin: 0;
    padding-right: 10px;
    min-width: 0;

    @media only screen and (max-width: 1400px) {
      .impacts-container {
        line-height: 20px;
      }
    }
    .buttonAudienceDetails {
      margin-top: 6px;
    }
  }
  .statusTitle {
    margin-top: 5px;
    margin-bottom: 1px;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: ${Colors.onPrimarySoft};
  }
  .statusContainer {
    background-color: ${Colors.snow};
    border-radius: 8px;
    margin-right: 0;
    padding: 2px 6px;
   }
   .statusName {
    margin: 0;
    color: ${Colors.primaryAccent};
    font-weight: 500;
    font-size: 14px;
    margin-right: 10px;
    font-weight: 600;
   }

   .statusPending {
    color: #B8860B;
   }

   .statusReady {
    color: #2E8B57;
   }

   .statusCancelled {
    color: #DC143C;
   }

   .statusPaused {
    color: ${Colors.textMuted};
   }
`;

export default CardCampaignStatusHolder;